<template>
  <div style="box-shadow: 0 0 0 0 !important" class="adminGraph">
    <v-row
      justify="center"
      class="mt-5 graphContent"
      style="margin: 0px; margin-bottom: -18px"
    >
    
      <DailyReportFilterForCustomerService @handleFilter="handleFilter" />
    </v-row>
 
    <div v-if="!getDataDone">
      <SliderGroup
        :options="this.options"
        @removeRow="removeRow($event)"
        style="margin-bottom: 30px"
      />

      <table-component
        itemKey="id"
        :headers="tableHeaders"
        :pagination="this.$store.state.pagination"
        :limit="$store.state.counterOfShow"
        :items="tableData"
        :loading="loading"
        v-model="page"
      >
        <template v-slot:[`item.التحكم`]="{ item }">
          <a :href="item.التحكم" style="text-decoration: none">
            <img src="@/assets/document-download-icon.svg" width="20px" height="30px" />
          </a>
        </template>
      </table-component>

      <div style="margin-top: 40px" v-if="!loading">
        <!-- <DailyReportChart :data="chartData" :headers="tableHeaders" /> -->
      </div>
    </div>
    <div v-else class="loader">
      <img src="../../../assets/Comp-2.gif" />
    </div>
  </div>
</template>

<script>
// import DailyReportChart from "./DailyReportChart";
import DailyReportFilterForCustomerService from "./DailyReportFilterForCustomerService.vue";
import SliderGroup from "@/components/Charts/SliderGroup.vue";
import Axios from "axios";

export default {
  components: {
    // DailyReportChart,
    DailyReportFilterForCustomerService,
    SliderGroup,
  },

  data() {
    return {
      chartData: [],
      tableData: [],
      options: [],
      showArray: [],
      filterObj: {},
      body: {},
      page: 1,
      getDataDone: false,
      loading: false,
      tableHeaders: [
        { text: "#", value: "index" },
        { text: "موظف خدمه العملاء", value: "موظف خدمه العملاء" },
        { text: "المستلمة", value: "المستلمة" },
        {
          text: "الطلبات الجديدة",
          value: "الطلبات الجديدة",
          width: "150px",
        },
        { text: "%الطلبات الجديدة", value: "%الطلبات الجديدة" },
        { text: "المتابعة", value: "المتابعة" },
        { text: "%المتابعة", value: "%المتابعة" },
        { text: "المؤرشفة", value: "المؤرشفة" },
        { text: "%المؤرشفة", value: "%المؤرشفة" },
        { text: "المكتملة", value: "المكتملة" },
        { text: "%المكتملة", value: "%المكتملة" },
        {
          text: "متابعة",
          value: "followed_basket_by_update_date",
          width: "92px",
          align: "center",
          csGroupStart: "حسب تاريخ التحديث",
          csGroupSpan: 3,
        },
        {
          text: "مؤرشفه",
          value: "archived_basket_by_update_date",
          width: "92px",
          align: "center",
          csGroupSkip: true,
        },
        {
          text: "مكتمله",
          value: "completed_request_by_update_date",
          width: "92px",
          align: "center",
          csGroupSkip: true,
        },
        { text: "المحدث عليها", value: "المحدث عليها", width: "120px" },
        // { text: "%المحدث عليها", value: "%المحدث عليها" },
        { text: "تم فتحها", value: "تم فتحها", width: "120px" },
        // { text: "%تم فتحها", value: "%تم فتحها" },
        // { text: "المهام المستلمة", value: "المهام المستلمة", width: "140px" },
        // { text: "المهام المرسلة", value: "المهام المرسلة", width: "130px" },
        // { text: "التذكيرات", value: "التذكيرات" },
        // {
        //   text: "الطلبات المحولة منه",
        //   value: "الطلبات المحولة منه",
        //   width: "160px",
        // },
        // {
        //   text: "الطلبات المحولة إليه",
        //   value: "الطلبات المحولة إليه",
        //   width: "160px",
        // },
        // {
        //   text: "( المستقبلة - المحولة منه )",
        //   value: "المستقبلة - المحولة منه",
        //   width: "160px",
        // },

        { text: "التحكم", value: "التحكم" },
      ],
    };
  },

  watch: {
    page(val) {
      this.getData(val, "loading");
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval !== oldvalue && !this.$store.state.admin_search_active) {
          this.getData(this.page);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },

  },

  methods: {
    removeRow(headerValue) {
      let findIndex = this.tableHeaders.findIndex((item) => item.text === headerValue);

      if (findIndex !== -1) {
        this.tableHeaders.splice(findIndex, 1);
        this.showArray.splice(findIndex, 0, {
          id: findIndex,
          value: headerValue,
        });
      } else {
        let foundInsertedItem = this.options.findIndex((item) => item === headerValue);

        this.showArray.sort((a, b) => a.id - b.id);
        this.showArray.map((res, index) => {
          if (res.value === headerValue) {
            this.tableHeaders.splice(foundInsertedItem - (index - 1), 0, {
              text: headerValue,
              value: headerValue,
            });
            this.showArray.splice(index, 1);
          }
        });
      }
    },

    handleFilter(val) {
      this.body = new FormData();

      // Add is_customer_service and role to get customer service employees only
      this.body.append("is_customer_service", 1);
      this.body.append("role", 0);

      if (val.startDate) {
        this.body.append("start_date", val.startDate);
      }

      if (val.endDate) {
        this.body.append("end_date", val.endDate);
      }

      if (val.status === "خدمه عملاء قائم") {
        this.body.append("status", 1);
      }

      if (val.status === "خدمه عملاء مؤرشف") {
        this.body.append("status", 0);
      }

      if (val.range) {
        this.body.append("range", val.range);
      }

      if (val.agentId.length) {
        const managerProperties = {};

        val.agentId.forEach((item, index) => {
          this.body.append([`adviser_id[${index}]`], item.id);
        });
      }

      if (val.dayNumber) {
        this.body.append("range", val.dayNumber);
      }
      this.$store.state.daily_report_search_body = this.body;
      this.getData(1, "getDataDone");
    },

    getData(page, loader) {
      if (loader === "getDataDone") {
        this.getDataDone = true;
      } else if (loader === "loading") {
        this.loading = true;
      }
      this.options = [];
      this.tableData = [];
      
      // Ensure is_customer_service and role are always in the body
      if (!this.body.has("is_customer_service")) {
        this.body.append("is_customer_service", 1);
      }
      if (!this.body.has("role")) {
        this.body.append("role", 0);
      }
      
      let url = `${this.$store.state.url}/employee/admin/getAllUsers?page=${page}&per_page=${this.$store.state.counterOfShow}&is_customer_service=1`;

      Axios.post(url, this.body, { headers: this.request_headers() }).then((res) => {
        this.setTableData(res.data.payload.data);
        this.setOptions();
        this.chartData = res.data.payload;
        this.$store.state.pagination = {
          limit: 3,
          count: res.data.payload.total_agents,
        };
        this.loading = false;
        this.getDataDone = false;
      });
    },

    setOptions() {
      this.tableHeaders.map((item, index) => {
        if (item.text !== "موظف خدمه العملاء" && item.text !== "التحكم") {
          this.options.push(item.text);
        }
      });
    },

    setTableData(data) {
      data.map((res,index) => {
        this.tableData.push({
          "index": index+1,
          "موظف خدمه العملاء": res.name,
          "مجموع الطلبات المستلمة": res.total_received_request?.count,
          "المستلمة": res.received_basket?.count,
          "الطلبات الجديدة": res.new_request?.count,
          "%الطلبات الجديدة": res.new_request?.percentage,
          // "المميزة": res.star_basket?.count,
          "المتابعة": res.followed_basket?.count,
          "%المتابعة": res.followed_basket?.percentage,
          "المؤرشفة": res.archived_basket?.count,
          "%المؤرشفة": res.archived_basket?.percentage,
          "المكتملة": res.completed_request?.count,
          "%المكتملة": res.completed_request?.percentage,
          "المحدث عليها": res.updated_request?.count,
          "%المحدث عليها": res.updated_request?.percentage,
          "تم فتحها": res.opened_request?.count,
          "%تم فتحها": res.opened_request?.percentage,
          "followed_basket_by_update_date": res.followed_basket_by_update_date?.count,
          "archived_basket_by_update_date": res.archived_basket_by_update_date?.count,
          "completed_request_by_update_date": res.completed_request_by_update_date?.count,
          "حسب_تحديث_متابعة":
            res.by_update_date_followed?.count ?? "—",
          "حسب_تحديث_مؤرشفه":
            res.by_update_date_archived?.count ?? "—",
          "حسب_تحديث_مكتمله":
            res.by_update_date_completed?.count ?? "—",
          "التحكم": res.report_pdf,
        });
      });
    },
  },

  created() {
    // Initialize body with is_customer_service and role
    this.body = new FormData();
    this.body.append("is_customer_service", 1);
    this.body.append("role", 0);
    // this.getData(1, "getDataDone");
    this.$store.state.pagination = {};
  },
};
</script>
